import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, SectionTitle, Intro } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Use a frame to contain content in a design. These classes should be
            used in conjunction with the{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/colors/develop'}
            >
              colors
            </Link>
            ,{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/stroke/develop'}
            >
              stroke
            </Link>{' '}
            and{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/shadow/develop'}
            >
              shadow
            </Link>{' '}
            classes to separate the content into visually distinct groups. The
            boundaries of a frame should be defined by either a stroke class or
            a shadow class, but never both.
          </p>
        </Intro>
        <SectionTitle>Frame Variants</SectionTitle>
        <p>
          There are three available frame variants: Rectangular with squared
          corners, Rectangulary with rounded corners, and Oval.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--rectangle"></span>
                  Rectangular Frame
                </div>
              </td>
              <td>Squared Corners</td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--rectangle-rounded"></span>
                  Rectangular Frame
                </div>
              </td>
              <td>Rounded Corners</td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--oval"></span>
                  Oval Frame
                </div>
              </td>
              <td>None</td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
